"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Packages = void 0;
const npm_check_updates_1 = __importDefault(require("npm-check-updates"));
const semver_1 = __importDefault(require("semver"));
const request_1 = __importDefault(require("./request"));
exports.Packages = {
    /**
     * 更新 npm 包
     * @param path package.json 文件路径
     * @param reject 排除不需要更新的包（支持字符串或字符串数组）
     * @returns 返回更新后的依赖配置对象
     */
    async update(path, reject) {
        const upgraded = await (0, npm_check_updates_1.default)({
            packageFile: path,
            upgrade: true,
            install: 'always',
            reject: reject,
        });
        return upgraded;
    },
    /**
     * 检查 CLI 版本
     * @param url CLI 发布的仓库/地址
     * @param localVersion 安装在 npm 全局目录下的本地 CLI 版本
     * @returns 若有新版本则返回包含名称和新版本号的对象，否则返回空对象
     */
    async checkVersion(url, localVersion) {
        let response = await request_1.default.ajax(url, 'get');
        if (response.status === 'success') {
            let remoteVersion = response.data['version']
                ? response.data['version']
                : response.data['dist-tags']['latest'];
            let res = semver_1.default.lt(localVersion, remoteVersion);
            if (res) {
                return {
                    name: response.data.name,
                    version: remoteVersion,
                };
            }
            else {
                return {};
            }
        }
        else {
            return {};
        }
    },
    /**
     * 查询 npm 包的最新版本
     * @param url npm 仓库地址
     * @param defaultVersion 网络错误时使用的默认版本号
     * @returns 返回版本号字符串
     */
    async getLatestVersion(url, defaultVersion) {
        let data = await request_1.default.ajax(url, 'get');
        if (data.status === 'success') {
            return data.data['version'];
        }
        else {
            return defaultVersion;
        }
    },
};
exports.default = exports.Packages;
